
import Vue, { PropType } from 'vue'
import { TranslateResult } from 'vue-i18n'
import MarkdownElement from '~/components/markdown/Element.vue'
import { convertLineBreaks } from '~/assets/ts/utils/strings'

export default Vue.extend({
  name: 'SearchSnippet',
  components: { MarkdownElement },
  props: {
    snippet: {
      type: String,
      default: undefined,
    },
    count: {
      type: Number,
      default: undefined,
    },
    countText: {
      type: String as PropType<TranslateResult>,
      default(): TranslateResult {
        return this.$t('{n} match | {n} matches')
        // return this.$t('{n} Match in Transcript | {n} Matches in Transcript')
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    countDisplay(): TranslateResult {
      const n = this.count || 0
      const display = n >= 100 ? `${n}+` : n
      return this.$tc(this.countText.toString(), n, { n: display })
    },
    displaySnippet(): string {
      return `“...${convertLineBreaks(this.snippet, ' ')}...”`
    },
  },
  methods: {},
})
